import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { DropdownModule } from 'primeng/dropdown';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CalendarModule } from 'primeng/calendar';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { TagModule } from 'primeng/tag';
import { SelectButtonModule } from 'primeng/selectbutton';
import { TableModule } from 'primeng/table';
import { FileUploadModule } from 'primeng/fileupload';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AddExpenseService } from '../../../services/add-expense.service';
import { AutocompleteService } from '../../../services/autocomplete.service';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { ExpenseRequestComplianceViewModel } from '../../../models/ExpenseRequestComplianceViewModel';
import { SelectListItem } from '../../../models/SelectListItem';


@Component({
  selector: 'expense-add-compliance',
  templateUrl: './expense-add-compliance.component.html',
  styleUrls: ['./expense-add-compliance.component.scss'],
  imports: [ButtonModule, CardModule, AutoCompleteModule, DropdownModule, CommonModule, CalendarModule, InputTextModule, InputTextareaModule, TagModule,
    SelectButtonModule, TableModule, FileUploadModule, ReactiveFormsModule, ToggleButtonModule],
  standalone: true,
  providers: [
    ConfirmationService,
    MessageService,
    AddExpenseService,
    AutocompleteService
  ],
})
export class ExpenseAddComplianceComponent implements OnInit {
  expensecomplianceForm!: FormGroup;
  childcampaignId: number = 0;
  @Input() campaignId!: number;
  @Input() expenseId!: number;
  @Input() expenseDetails: any;
  @Input() confirmAction!: (
    message: string,
    acceptCallback: () => void,
    rejectCallback?: () => void
  ) => void;
  @Output() prevCallback = new EventEmitter<void>();
  @Output() nextCallback = new EventEmitter<void>();
  @Output() errorEvent = new EventEmitter<string>();
  onIcon: string = 'pi pi-check';
  complianceModel!: ExpenseRequestComplianceViewModel;
  lineNumbers: SelectListItem[] = [];
  showfederal = false;

  constructor(private fb: FormBuilder, private addExpenseService: AddExpenseService, private autoCompleteService: AutocompleteService, private confirmationService: ConfirmationService) { }

  ngOnInit(): void {
    this.expensecomplianceForm = this.fb.group({
      campaignId: [this.campaignId],
      expenseComplianceRequestId: [this.expenseId],
      expenseComplianceFundCode: [''],
      expenseComplianceFundCodeDescription: [''],
      expenseComplianceFundElection: [''],
      expenseComplianceFundElectionYear: [''],
      expenseComplianceId: [''],
      expenseComplianceLineNumber: ['', Validators.required],
      allocatedActivityTypeId: [''],
      federalShare: [''],
      nonFederalShare: [''],
      total: [''],
      expenseComplianceMemo: [''],
      expenseComplianceMemoText: [''],
      expenseComplianceDescription: [''],
    });
    this.addExpenseService.getExpensecompliance(this.expenseId, this.campaignId, this.childcampaignId).subscribe({
      next: (data) => {
        console.debug(data);
        this.complianceModel = data;
        this.lineNumbers = data.expenseComplianceLineNumbersLookup;
        this.initForm();
        this.CheckToShowFederal(this.complianceModel.expenseComplianceLineNumber?.toString());
        this.expensecomplianceForm.get('expenseComplianceLineNumber')?.valueChanges.subscribe(expenseComplianceLineNumber => {
          if (expenseComplianceLineNumber) {
            this.CheckToShowFederal(expenseComplianceLineNumber);
          }
        });
      },
      error: () => {
        this.errorEvent.emit('Failed to get compliance data!');
      }
    })
  }

  private CheckToShowFederal(expenseComplianceLineNumber: any) {
    if (expenseComplianceLineNumber === "226") {
      this.showfederal = true;
    }
    else {
      this.showfederal = false;
    }
  }

  initForm() {
    this.expensecomplianceForm = this.fb.group({
      campaignId: [this.campaignId],
      expenseComplianceRequestId: [this.complianceModel.expenseComplianceRequestId],
      expenseComplianceFundCode: [this.complianceModel.expenseComplianceFundCode],
      expenseComplianceFundCodeDescription: [this.complianceModel.expenseComplianceFundCodeDescription],
      expenseComplianceFundElection: [this.complianceModel.expenseComplianceFundElection],
      expenseComplianceFundElectionYear: [this.complianceModel.expenseComplianceFundElectionYear],
      expenseComplianceId: [this.complianceModel.expenseComplianceId],
      expenseComplianceLineNumber: [this.complianceModel.expenseComplianceLineNumber?.toString(), Validators.required],
      allocatedActivityTypeId: [this.complianceModel.allocatedActivityTypeId],
      federalShare: [this.complianceModel.federalShare],
      nonFederalShare: [this.complianceModel.nonFederalShare],
      total: [this.complianceModel.total],
      expenseComplianceMemo: [this.complianceModel.expenseComplianceMemo],
      expenseComplianceMemoText: [this.complianceModel.expenseComplianceMemoText],
      expenseComplianceDescription: [this.complianceModel.expenseComplianceDescription],
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['expenseDetails']?.currentValue) {
      console.debug('Received expense details from step 1:', this.expenseDetails);
      this.childcampaignId = this.expenseDetails.childCampaignId;
    }
  }

  onSubmit() {
    // Perform any validation or data processing here
    if (this.expensecomplianceForm.valid) {
      console.debug(this.expensecomplianceForm.value);
      this.addExpenseService.saveExpenseCompliance(this.expensecomplianceForm.value).subscribe({
        next: (success) => {
          if (success)
            this.nextCallback.emit();
        },
        error: () => {
          this.errorEvent.emit('Failed to save Expense Details');
        }
      });
    } else {
      this.markAllAsTouched(this.expensecomplianceForm);
    }
  }

  markAllAsTouched(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((field) => {
      formGroup.get(field)?.markAsTouched();
    });
  }

  onSaveExpense(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (this.expensecomplianceForm.valid) {
        console.debug(this.expensecomplianceForm.value);
        this.addExpenseService.saveExpenseCompliance(this.expensecomplianceForm.value).subscribe({
          next: (success) => {
            resolve(true);
          },
          error: () => {
            this.errorEvent.emit('Failed to save Expense Details');
            resolve(false);
          }
        });
      } else {
        this.markAllAsTouched(this.expensecomplianceForm);
        resolve(false);
      }
    });
  }
}